/** 修改密码(博颂 2026-09-22):老师被邀请进来后自己改密码。走 school-backend
 *  代理到 nova-os /api/auth/change-password,带当前登录的 Bearer。 */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { authHeaders } from "../api/school";

export function ChangePasswordModal({ onClose }: { onClose: () => void }): JSX.Element {
  const { t } = useTranslation();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [again, setAgain] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const mismatch = next.length > 0 && again.length > 0 && next !== again;
  async function submit() {
    setBusy(true); setErr(null);
    try {
      const r = await fetch("/api/school/account/change-password", { method: "POST", headers: { ...authHeaders(), "Content-Type": "application/json" }, body: JSON.stringify({ current_password: cur, new_password: next }) });
      const b = (await r.json().catch(() => ({}))) as { detail?: unknown };
      if (!r.ok) throw new Error(typeof b.detail === "string" ? b.detail : `HTTP ${r.status}`);
      setDone(true);
    } catch (e) { setErr((e as Error).message); } finally { setBusy(false); }
  }
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4" onClick={onClose}>
      <div className="w-full max-w-sm rounded-xl bg-white p-5 shadow-xl" onClick={(e) => e.stopPropagation()} data-testid="change-password-modal">
        <h3 className="mb-3 text-sm font-semibold text-slate-800">{t("account.changePassword")}</h3>
        {done ? (
          <>
            <p className="text-sm text-emerald-700">{t("account.changed")}</p>
            <div className="mt-4 text-right"><button type="button" onClick={onClose} className="rounded bg-sky-500 px-3 py-1 text-sm text-white">{t("common.close")}</button></div>
          </>
        ) : (
          <>
            <label className="block text-xs text-slate-600">{t("account.current")}<input type="password" autoComplete="current-password" value={cur} onChange={(e) => setCur(e.target.value)} className="mt-1 w-full rounded border border-slate-200 px-2 py-1.5 text-sm" /></label>
            <label className="mt-3 block text-xs text-slate-600">{t("account.new")}<input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} className="mt-1 w-full rounded border border-slate-200 px-2 py-1.5 text-sm" /></label>
            <label className="mt-3 block text-xs text-slate-600">{t("account.again")}<input type="password" autoComplete="new-password" value={again} onChange={(e) => setAgain(e.target.value)} className="mt-1 w-full rounded border border-slate-200 px-2 py-1.5 text-sm" /></label>
            <p className="mt-1 text-[11px] text-slate-400">{t("account.rule")}</p>
            {mismatch && <p className="mt-1 text-xs text-rose-600">{t("account.mismatch")}</p>}
            {err && <p className="mt-1 text-xs text-rose-600">{err}</p>}
            <div className="mt-4 flex justify-end gap-2">
              <button type="button" onClick={onClose} className="rounded border border-slate-300 px-3 py-1 text-sm">{t("common.cancel")}</button>
              <button type="button" disabled={busy || !cur || next.length < 8 || mismatch} onClick={() => void submit()} className="rounded bg-sky-500 px-3 py-1 text-sm font-medium text-white hover:bg-sky-600 disabled:opacity-50">{t("common.save")}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
